import {
  SCIM_CONFIGURATION_TAB,
  SINGLE_SIGN_ON_TAB,
} from 'common/constants/firms';
import {
  FIRM_WATERFALL,
  USER_MANAGEMENT_TAB,
} from 'common/constants/user';

export const FIRM_NAVIGATION_IDS = {
  SUMMARY: 'summary',
  SETTINGS: 'edit-firm',
  COMP_GROUPS: 'comp-groups',
  USER_MANAGEMENT: USER_MANAGEMENT_TAB,
  WATERFALL: FIRM_WATERFALL,
  SINGLE_SIGN_ON: SINGLE_SIGN_ON_TAB,
  SCIM_CONFIGURATION: SCIM_CONFIGURATION_TAB,
} as const;
